
export const getToken = (): string | null => {
    // Attempt to find Supabase token in localStorage
    // Key pattern usually: sb-<ref>-auth-token
    // But we might not know REF dynamically.
    // We search for any key matching the pattern.
    if (typeof localStorage === 'undefined') return null;

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('sb-') && key.endsWith('-auth-token')) {
            try {
                const session = JSON.parse(localStorage.getItem(key) || '{}');
                if (session && session.access_token) {
                    return session.access_token;
                }
            } catch {
                continue;
            }
        }
    }
    return null;
}
